import type { ProductCategory } from "@/stores/products";

export const isCampaignActive = import.meta.env.VITE_CAMPAIGN_ACTIVE === "true";

export interface Campaign {
  code: string;
  value: number;
  type: "value" | "percentage";
  bgColor: string;
  textColor: string;
  campaignFor: { [key in ProductCategory]: boolean };
}

export interface CampaignTrackerType {
  newCampaign: Campaign;
  oldCampaign: Campaign;
}

export const CampaignTracker: CampaignTrackerType = {
  newCampaign: {
    code: "welcome33",
    value: 33,
    type: "percentage",
    bgColor: "#8BE100",
    textColor: "#062344",
    campaignFor: {
      bioniq_go_light: false,
      bioniq_go_subscription: true,
    },
  },
  oldCampaign: {
    code: "BF50",
    value: 50,
    type: "percentage",
    bgColor: "#021223",
    textColor: "white",
    campaignFor: {
      bioniq_go_light: false,
      bioniq_go_subscription: true,
    },
  },
};

export const ExcludedCountriesFromNewCampaign: string[] = [];
